import api from './api';

const authService = {
  login: (credentials) => {
    return api.post('/auth/login', credentials);
  },
  
  logout: () => {
    return api.post('/auth/logout');
  },
  
  getCurrentUser: () => {
    return api.get('/auth/me');
  },
};

export default authService;
